export default __webpack_public_path__ + "b0ddd5f1e1e603cf86d953a7d6b65208.jpg";